module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "uploadContainer",
    staticStyle: {
      "overflow": "hidden !important"
    },
    attrs: {
      "grid-list-xl": "",
      "quoteSettingsContainer": ""
    }
  }, [_c('v-form', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('h2', [_vm._v("Delivery signed and accepted by:")])]) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Name:")])]) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name",
      "solo": ""
    },
    model: {
      value: (_vm.metaData.name),
      callback: function($$v) {
        _vm.$set(_vm.metaData, "name", $$v)
      },
      expression: "metaData.name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg9": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Surname:")])]) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Surname",
      "solo": ""
    },
    model: {
      value: (_vm.metaData.surname),
      callback: function($$v) {
        _vm.$set(_vm.metaData, "surname", $$v)
      },
      expression: "metaData.surname"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg9": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("ID No:")])]) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ID No",
      "solo": ""
    },
    model: {
      value: (_vm.metaData.idNo),
      callback: function($$v) {
        _vm.$set(_vm.metaData, "idNo", $$v)
      },
      expression: "metaData.idNo"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg9": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Location:")])]) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Location",
      "solo": ""
    },
    model: {
      value: (_vm.metaData.location),
      callback: function($$v) {
        _vm.$set(_vm.metaData, "location", $$v)
      },
      expression: "metaData.location"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg9": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Employer:")])]) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Employer",
      "solo": ""
    },
    model: {
      value: (_vm.metaData.employer),
      callback: function($$v) {
        _vm.$set(_vm.metaData, "employer", $$v)
      },
      expression: "metaData.employer"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg9": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg9": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncSaveMeta.apply(null, arguments)
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncCancelMeta.apply(null, arguments)
      }
    }
  }, [_vm._v("Update Later")])], 1) : _vm._e(), _vm._v(" "), (!_vm.showMeta && _vm.globalModalParams.vendor != 0 && (_vm.globalModalParams.vendor != undefined || _vm.globalModalParams.vendor != 'undefined')) ? _c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    },
    model: {
      value: (_vm.selectedIndex),
      callback: function($$v) {
        _vm.selectedIndex = $$v
      },
      expression: "selectedIndex"
    }
  }, [_c('v-tab', {
    key: _vm.tabkeys[0],
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Quote Attachments")]), _vm._v(" "), _c('v-tab', {
    key: _vm.tabkeys[1],
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Purchase Order Attachments")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "50%",
      "margin-top": "10px"
    }
  }, [_c('p', [_vm._v("Please select a file to upload and click the \"Upload\" button to continue")]), _vm._v(" "), _c('p', {
    staticClass: "smalltext"
  }, [_vm._v("Maximum file size allowed: " + _vm._s(_vm.objAuthorize.max_upload_size) + "MB")]), _vm._v(" "), _c('p', {
    staticClass: "smalltext"
  }, [_vm._v("File types supported: " + _vm._s(_vm.objAuthorize.allowed_file_types))]), _vm._v(" "), (_vm.attachmentCategories.length > 1) ? _c('v-checkbox', {
    staticClass: "normalCheckbox",
    attrs: {
      "label": "View All Documents"
    },
    on: {
      "change": function($event) {
        return _vm.fncViewAllDocuments()
      }
    },
    model: {
      value: (_vm.viewAllDocs),
      callback: function($$v) {
        _vm.viewAllDocs = $$v
      },
      expression: "viewAllDocs"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "50%",
      "margin-top": "10px"
    }
  }, [(_vm.attachmentCategories.length > 1) ? _c('div', [(_vm.uploadError == true) ? _c('small', {
    staticClass: "uploadError"
  }, [_vm._v("Please select a category, and then reupload the file.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "fileUpload",
    staticStyle: {
      "padding-top": "30px !important",
      "padding-bottom": "30px !important"
    },
    attrs: {
      "type": "file",
      "id": "quoteFile"
    },
    on: {
      "change": _vm.fncSetImageObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fileHolder",
    staticStyle: {
      "height": "85px !important"
    }
  }, [_c('p', [_vm._v("Drag & Drop / Click to Add Files")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.fileName))])])]), _vm._v(" "), (_vm.quoteSettings.attachments.length != 0 && _vm.busyUploading == 0) ? _c('p', {
    staticStyle: {
      "width": "50% !important"
    }
  }, [_vm._v("Filter attachment categories")]) : _vm._e(), _vm._v(" "), (_vm.quoteSettings.attachments.length != 0 && _vm.busyUploading == 0) ? _c('v-select', {
    staticClass: "dropdown",
    staticStyle: {
      "width": "50% !important"
    },
    attrs: {
      "items": _vm.attachmentCategories,
      "label": "Attachment Category",
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncFilterAttachments()
      }
    },
    model: {
      value: (_vm.selectedAttachmentCategory),
      callback: function($$v) {
        _vm.selectedAttachmentCategory = $$v
      },
      expression: "selectedAttachmentCategory"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.quoteSettings.attachments.length != 0 && _vm.busyUploading == 0) ? _c('v-data-table', {
    staticClass: "elevation-1 attachmentList",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredAttachments,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncOpenFile(props.item.path)
            }
          }
        }, [_vm._v(_vm._s(props.item.original_filename))])]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncOpenFile(props.item.path)
            }
          }
        }, [_vm._v(_vm._s(_vm.fncGetLocalizedDateFromUTC(props.item.created_timestamp)))])]), _vm._v(" "), (_vm.attachmentCategories.length > 1) ? _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          attrs: {
            "items": _vm.attachmentCategories,
            "label": "Attachment Category",
            "item-value": "id",
            "item-text": "name",
            "solo": "",
            "single-line": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncSaveAttachmentCategory(props.item)
            }
          },
          model: {
            value: (props.item.category),
            callback: function($$v) {
              _vm.$set(props.item, "category", $$v)
            },
            expression: "props.item.category"
          }
        })], 1) : _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v("N/A")]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.fullname))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncRemoveImage(props.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])])]
      }
    }], null, false, 3995067911)
  }) : _vm._e(), _vm._v(" "), (_vm.busyUploading == 1) ? _c('p', {
    staticClass: "waitingUpload"
  }, [_c('strong', [_vm._v("Uploading... Please wait...")])]) : _vm._e()], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "50%",
      "margin-top": "10px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("These are attachments that were loaded by the Vendor on the Vendor portal.")]), _vm._v(" "), _c('p', [_vm._v("Please select a file to upload and click the \"Upload\" button to continue")]), _vm._v(" "), _c('p', {
    staticClass: "smalltext"
  }, [_vm._v("Maximum file size allowed: " + _vm._s(_vm.objAuthorize.max_upload_size) + "MB")]), _vm._v(" "), _c('p', {
    staticClass: "smalltext"
  }, [_vm._v("File types supported: " + _vm._s(_vm.objAuthorize.allowed_file_types))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "45%",
      "margin-top": "10px"
    }
  }, [(_vm.attachmentCategories.length > 1) ? _c('div', [(_vm.uploadError == true) ? _c('small', {
    staticClass: "uploadError"
  }, [_vm._v("Please select a category, and then reupload the file.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "fileUpload",
    staticStyle: {
      "padding-top": "30px !important",
      "padding-bottom": "30px !important"
    },
    attrs: {
      "type": "file",
      "id": "quoteFile"
    },
    on: {
      "change": _vm.fncSetSoImageObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fileHolder",
    staticStyle: {
      "height": "85px !important"
    }
  }, [_c('p', [_vm._v("Drag & Drop / Click to Add Files")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.fileName))])])]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 attachmentList",
    attrs: {
      "headers": _vm.soHeaders,
      "items": _vm.quoteSettings.details.soAttachments,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncOpenFile(props.item.path)
            }
          }
        }, [_vm._v(_vm._s(props.item.original_filename))]), _vm._v(" "), (_vm.fncCanUpdatePod(props.item) && props.item.meta_data != null) ? _c('div', {
          staticStyle: {
            "margin-top": "10px",
            "text-indent": "5px"
          }
        }, [_c('b', [_vm._v("Delivery signed and Received by:")]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Name:")]), _vm._v(" " + _vm._s(JSON.parse(props.item.meta_data).name) + " " + _vm._s(JSON.parse(props.item.meta_data).surname))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("ID No:")]), _vm._v(" " + _vm._s(JSON.parse(props.item.meta_data).idNo))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Location:")]), _vm._v(" " + _vm._s(JSON.parse(props.item.meta_data).location))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Employer:")]), _vm._v(" " + _vm._s(JSON.parse(props.item.meta_data).employer))])]) : _vm._e()]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncOpenFile(props.item.path)
            }
          }
        }, [_vm._v(_vm._s(_vm.fncGetLocalizedDateFromUTC(props.item.created_timestamp)))])]), _vm._v(" "), (_vm.attachmentCategories.length > 1) ? _c('td', {
          staticClass: "text-xs-left",
          attrs: {
            "width": "20%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          attrs: {
            "items": _vm.attachmentCategories,
            "label": "Attachment Category",
            "item-value": "id",
            "item-text": "name",
            "solo": "",
            "single-line": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncSaveAttachmentCategory(props.item)
            }
          },
          model: {
            value: (props.item.category),
            callback: function($$v) {
              _vm.$set(props.item, "category", $$v)
            },
            expression: "props.item.category"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "30%"
          }
        }, [_c('div', {
          staticStyle: {
            "margin-top": "10px",
            "font-size": "12px !important",
            "display": "flex",
            "justify-content": "space-between"
          }
        }, [(_vm.fncCanUpdatePod(props.item)) ? _c('v-btn', {
          style: (_vm.getStyle()),
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.fncShowMeta(props.item.id, props.item.meta_data)
            }
          }
        }, [_vm._v("UPDATE ORDER RECIPIENT DETAILS")]) : _vm._e(), _vm._v(" "), (_vm.fncCanUpdatePod(props.item) && _vm.fncCheckStatus(props.index) && _vm.quoteSettings.details.status !== 'POD Uploaded') ? _c('v-btn', {
          staticStyle: {
            "width": "48%"
          },
          attrs: {
            "color": "info"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.fncCheckPodStatus())
          },
          on: {
            "click": function($event) {
              return _vm.fncUpdatePodStatus(props.item.id, props.index)
            }
          }
        }) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          attrs: {
            "width": "5%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncRemoveFile(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_c('v-checkbox', {
          on: {
            "change": function($event) {
              return _vm.fncMarkPaid(props.item)
            }
          },
          model: {
            value: (props.item.is_paid),
            callback: function($$v) {
              _vm.$set(props.item, "is_paid", $$v)
            },
            expression: "props.item.is_paid"
          }
        })], 1)])]
      }
    }], null, false, 4235451748)
  })], 1)], 1) : (_vm.showMeta == false) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "50%",
      "margin-top": "10px"
    }
  }, [_c('p', [_vm._v("Please select a file to upload and click the \"Upload\" button to continue")]), _vm._v(" "), _c('p', {
    staticClass: "smalltext"
  }, [_vm._v("Maximum file size allowed: " + _vm._s(_vm.objAuthorize.max_upload_size) + "MB")]), _vm._v(" "), _c('p', {
    staticClass: "smalltext"
  }, [_vm._v("File types supported: " + _vm._s(_vm.objAuthorize.allowed_file_types))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "50%",
      "max-height": "120px",
      "margin-top": "10px"
    }
  }, [_c('input', {
    staticClass: "fileUpload",
    staticStyle: {
      "padding-top": "30px !important",
      "padding-bottom": "30px !important"
    },
    attrs: {
      "type": "file",
      "id": "quoteFile"
    },
    on: {
      "change": _vm.fncSetImageObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fileHolder",
    staticStyle: {
      "height": "85px !important"
    }
  }, [_c('p', [_vm._v("Drag & Drop / Click to Add Files")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.fileName))])])]), _vm._v(" "), (_vm.quoteSettings.attachments.length == 0 && _vm.busyUploading == 0) ? _c('small', {
    staticClass: "pt-4 pb-4",
    staticStyle: {
      "margin-top": "20px",
      "border-top": "1px solid #ECECEC",
      "width": "100%",
      "float": "left"
    }
  }, [_c('strong', [_vm._v("No attachments has been uploaded to this quote")])]) : _vm._e(), _vm._v(" "), (_vm.quoteSettings.attachments.length != 0 && _vm.busyUploading == 0) ? _c('p', [_vm._v("Filter attachment categories")]) : _vm._e(), _vm._v(" "), (_vm.quoteSettings.attachments.length != 0 && _vm.busyUploading == 0) ? _c('v-select', {
    staticClass: "dropdown",
    staticStyle: {
      "width": "50% !important"
    },
    attrs: {
      "items": _vm.attachmentCategories,
      "label": "Attachment Category",
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncFilterAttachments()
      }
    },
    model: {
      value: (_vm.selectedAttachmentCategory),
      callback: function($$v) {
        _vm.selectedAttachmentCategory = $$v
      },
      expression: "selectedAttachmentCategory"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.quoteSettings.attachments.length != 0 && _vm.busyUploading == 0) ? _c('v-data-table', {
    staticClass: "elevation-1 attachmentList",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredAttachments,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncOpenFile(props.item.path)
            }
          }
        }, [_vm._v(_vm._s(props.item.original_filename))])]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncOpenFile(props.item.path)
            }
          }
        }, [_vm._v(_vm._s(_vm.fncGetLocalizedDateFromUTC(props.item.created_timestamp)))])]), _vm._v(" "), (_vm.attachmentCategories.length > 1) ? _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          attrs: {
            "items": _vm.attachmentCategories,
            "label": "Attachment Category",
            "item-value": "id",
            "item-text": "name",
            "solo": "",
            "single-line": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncSaveAttachmentCategory(props.item)
            }
          },
          model: {
            value: (props.item.category),
            callback: function($$v) {
              _vm.$set(props.item, "category", $$v)
            },
            expression: "props.item.category"
          }
        })], 1) : _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "25%"
          }
        }, [_vm._v("N/A")]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.fncFileOwner(props.item.fullname))
          }
        }), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncRemoveImage(props.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])])]
      }
    }], null, false, 927663839)
  }) : _vm._e(), _vm._v(" "), (_vm.busyUploading == 1) ? _c('center', {
    staticClass: "waitingUpload"
  }, [_c('img', {
    attrs: {
      "width": "200",
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncDeleteAttachments.apply(null, arguments)
      }
    }
  }, [_vm._v("Delete All Attachments")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}